import { createCommunicationSelectors } from 'src/helpers/redux'
import { IState, PREFIX, TGlobalStateWithService } from './state'
import { actions } from './actions'
import { createSelector } from 'reselect'
import { ITeamMemberPresence, TUserStatus } from 'src/services/auth/users'

export const selectCommunication = (
  state: TGlobalStateWithService
): IState['communication'] => state[PREFIX].communication

export const selectData = (state: TGlobalStateWithService): IState['data'] =>
  state[PREFIX].data

export const communications = createCommunicationSelectors<
  TGlobalStateWithService,
  IState['communication'],
  typeof actions
>(selectCommunication, actions)

const STATUS_ORDER: Record<TUserStatus, number> = {
  online: 0,
  away: 1,
  dnd: 2,
  offline: 3,
}

const memberName = (member: ITeamMemberPresence) =>
  `${member.info?.firstName ?? ''} ${member.info?.lastName ?? ''}`.trim() ||
  member.identifier ||
  ''

export const selectors = {
  team: createSelector(selectData, (state) => state.team),
  isTeamLoaded: createSelector(selectData, (state) => state.isTeamLoaded),
  /** online first, then away, then do-not-disturb; by name inside a group */
  teamList: createSelector(selectData, (state) =>
    Object.values(state.team).sort(
      (a, b) =>
        STATUS_ORDER[a.status] - STATUS_ORDER[b.status] ||
        memberName(a).localeCompare(memberName(b))
    )
  ),
}
